var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"dzs-button",class:{
    [`dzs-button-${_vm.type}`]: _vm.type,
    [`dzs-button-${_vm.size}`]: _vm.size,
    [`dzs-button-disabled`]: _vm.disabled,
    [`dzs-button-text`]: _vm.text,
    ['isplain']: _vm.plain,
    ['isround']: _vm.round,
    ['iscircle']: _vm.circle,
    [`${_vm.className}`]: _vm.className
},attrs:{"disabled":_vm.disabled,"type":_vm.nativeType},on:{"click":_vm.onClick}},[_vm._t("icon"),(_vm.icon)?_c('i',{staticClass:"dzs-button-icon",class:_vm.icon}):_vm._e(),_c('span',[_vm._t("default")],2),_vm._t("icon-right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }